module.exports = __webpack_public_path__ + "media/images/front/varieties/NAVEL-CARA-CARA-9c00dcd39ec7eafbbe97c1a29fe571c6.jpg";